import { z } from 'zod';

/**
 * DTO schemas describe EXACTLY what the Laravel backend returns.
 * They live behind the adapter and never leak past the mapper.
 *
 * Field names mirror the backend (snake_case, nested user object, etc.) so changes on
 * the backend are caught at parse-time, not silently propagated into the domain.
 */
export const userDto = z.object({
  id: z.union([z.string(), z.number()]).transform(String),
  email: z.string().email(),
  name: z.string(),
  first_name: z.string().default(''),
  surname: z.string().default(''),
  id_number: z.string().default(''),
  address: z.string().default(''),
  phone: z.string().default(''),
  locale: z.string(),
  roles: z.array(z.string()).default([]),
  created_at: z.string(),
});

export const authSessionDto = z.object({
  user: userDto,
  token: z.string(),
  expires_at: z.string(),
});

export const okResponseDto = z.object({
  ok: z.boolean(),
  status: z.string().optional(),
});

export const socialRedirectUrlDto = z.object({
  url: z.string().url(),
});

export type UserDto = z.infer<typeof userDto>;
export type AuthSessionDto = z.infer<typeof authSessionDto>;
